export default {
    en: {
        footer_service_intro: "Service Introduction",
        footer_business_info: "Business Info",
        footer_company_name: "Company Name: Pocket Memory Co., Ltd.",
        footer_representative: "Representative: Jo Yong-seok",
        footer_registration_number: "Business Registration Number: 107-88-22036",
        footer_address: "Address: Room 1216, Ace NS Tower, 8 Mullae-buk-ro, Yeongdeungpo-gu, Seoul",
        footer_mail_order_license: "Mail Order License: 2015-Seoul Guro-0416",
        footer_privacy_officer: "Privacy Officer: Jo Yong-seok",
        footer_customer_center: "Customer Center",
        footer_email: "Email: support@pmautotwin.com",
        footer_phone: "Phone: 02-2088-1855",
        footer_operating_hours: "Operating Hours: Weekdays 11:00 - 18:00 (Closed on Weekends/Holidays)"
    },
    ko: {
        footer_service_intro: "서비스소개",
        footer_business_info: "사업자 정보",
        footer_company_name: "상호명: (주)포켓메모리",
        footer_representative: "대표자: 조용석",
        footer_registration_number: "사업자등록번호: 107-88-22036",
        footer_address: "주소: 서울특별시 영등포구 문래북로8, 에이스NS타워 1216호",
        footer_mail_order_license: "통신판매업 신고번호: 2015-서울구로-0416",
        footer_privacy_officer: "개인정보관리책임자: 조용석",
        footer_customer_center: "고객센터",
        footer_email: "이메일: support@pmautotwin.com",
        footer_phone: "전화번호: 02-2088-1855",
        footer_operating_hours: "운영시간: 평일 11:00 - 18:00 (주말/공휴일 휴무)"
    },
    ja: {
        footer_service_intro: "サービス紹介",
        footer_business_info: "事業者情報",
        footer_company_name: "商号: (株)ポケットメモリー",
        footer_representative: "代表者: チョ・ヨンソク",
        footer_registration_number: "事業者登録番号: 107-88-22036",
        footer_address: "住所: ソウル特別市永登浦区文来北路8、エースNSタワー1216号",
        footer_mail_order_license: "通信販売業申告番号: 2015-ソウル九老-0416",
        footer_privacy_officer: "個人情報管理責任者: チョ・ヨンソク",
        footer_customer_center: "カスタマーセンター",
        footer_email: "Eメール: support@pmautotwin.com",
        footer_phone: "電話番号: 02-2088-1855",
        footer_operating_hours: "営業時間: 平日 11:00 - 18:00 (週末/祝日休み)"
    }
};
